import {Component, Input, OnInit, TemplateRef, ViewChild, ViewEncapsulation} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ToastService} from "@shared/services/toast.service";
import {DashboardService} from "@app/features/dashboard/dashboard.service";
import {DataService} from "@shared/services/data.service";


@Component({
  selector: 'maalchat-crm-export-csv-modal',
  templateUrl: './export-csv-modal.component.html',
  styleUrls: ['./export-csv-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExportCsvModalComponent implements OnInit {
  @ViewChild('exportCSV', {static: true}) exportCSV: TemplateRef<BsModalRef> | any;
  modalRef: BsModalRef | any;
  public email = '';
  @Input() path: string | undefined;
  @Input() params: any;
  public exportPath: string | undefined;
  public exportParams: any;
  public loading = false;


  constructor(private modalService: BsModalService,
              private toastr: ToastService,
              private dataService: DataService,
              public dashboardService: DashboardService) {
  }

  ngOnInit() {
  }

  public open() {
    this.email = '';
    this.loading = false;
    this.modalRef = this.modalService.show(this.exportCSV);
  }

  public close() {
    this.email = '';
    this.modalRef.hide();
  }

  public sendCSV() {
    this.loading = true;
    const path = this.exportPath || this.path;
    const params = this.exportParams != null ? this.exportParams : this.params;
    this.dataService.sendCSV(this.email, path, params).subscribe((res) => {
        this.loading = false;
        this.toastr.success('Sent Successfully');
        this.close();
      },
      error => {
        this.loading = false;
        console.log(error);
      });
  }
}
